// @flow
export default function hasClass(element: HTMLElement, cls: string) {
   if (!element) return false;

   return !!element.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}
